export const timelineColors = {
  bg: "#f6f9fb", // --color-timeline-bg
  panel: "#eff3f6", // --color-timeline-panel
  border: "#e4e4e4", // --color-timeline-border
  accent: "#0b84f3", // --color-timeline-accent
  scrollbarTrack: "rgba(255, 255, 255, 0.04)", // --color-timeline-scrollbar-track
  scrollbarThumb: "red", // --color-timeline-scrollbar-thumb
};
